export default "__VITE_ASSET__DgKybtjD__"